/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-07 14:41:19
 * @LastEditTime: 2025-03-03 11:01:02
 * @LastEditors: ywj@originqc.com
 */
import React, { useState } from 'react'
import './index.scss'

interface ITab { 
  data: Array<{ id: number; name: string }>,
  setTabId:(id:number)=>void,
}
const MiniTab: React.FC<ITab> = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const { data, setTabId } = props;
  const handleTabClick = (tab:any,index: number) => {
    setActiveTab(index);
    setTabId(tab?.id);
  };
  return (
    <div className="tab-container">
    <div className="tab-header">
      {data.length>0&&data?.map((tab:any, index:number) => (
        <div
          key={index}
          className={`tab ${activeTab === index ? 'active' : ''}`}
          onMouseEnter={() => handleTabClick(tab,index)}
        >
          {tab.name}
        </div>
      ))}
    </div>
    {/* <div className="tab-content">
      {tabs[activeTab].content}
    </div> */}
  </div>
  )
}

export default MiniTab;